// ----------------------------------------------------------------------

const account = {
  displayName: 'HNP',
  email: 'HNP',
  photoURL: '/static/hnp-images/Sample_User_Icon.png'
};

export default account;
